import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	rootTitle: {
		id: 'onboarding-quickstart-core.utils.create-task-list.root-title',
		defaultMessage: 'Quickstart',
		description: 'Initial title of Quickstart for hard-coded quickstart tasks',
	},
});
